import {deleteToken, getToken} from "./token";
import firebase from "firebase/app";
import 'firebase/app';

export const signOut = () => {
    // const [globalPersistentState, globalPersistentActions] = usePersistentStore() // cannot use hooks!

    deleteToken();
    firebase.auth().signOut();
    // globalPersistentActions.clearStorage();
};

export const isSignedIn = () => {
    const t = getToken();
    return !!t;
};
